import * as React from "react";

import {isApiFalse}             from "@Common/logic/is-api-false";
import {isApiTrue}              from "@Common/logic/is-api-true";
import {ReCaptcha}              from "@Common/ui-components/recaptcha/recaptcha";
import {FloatingInput}          from "@Xpresso/routes/account/common/floating-labels/floating-input";
import {modifyWhiteElement}     from "@Xpresso/routes/brand/branded-login/branded-login";
import {AlertModal}             from "@Common/ui-components/alert-modal/alert-modal";
import {BrandedCreateAccount}   from "../branded-create-account/branded-create-account";

import "./branded-login-form.scss";

export const BrandedLoginForm = ({routerHistory, themeScheme}) => {
    const [credentials, setCredentials] = React.useState({username: "", password: "", captcha: "", isGuest: false})
    const [loginInProcess, setLoginInProcess] = React.useState(false)
    const [showCredentialMismatch, setShowCredentialMismatch] = React.useState(false)
    const query = new URLSearchParams(window.location.search)
    const invert = modifyWhiteElement(themeScheme?.xpresso?.menuBackgroundColor)

    const buttonEnabled = () => {
        if(loginInProcess) {
            return false
        }
        if(!credentials.username) {
            return false
        }
        if(!credentials.captcha) {
            return false
        }
        const passwordMin = 6
        if(credentials.password.length < passwordMin) {
            return false
        }

        return true
    }

    const handleSubmit = async () => {
        setLoginInProcess(true)

        const res = await fetch('/next-api/authenticate/login', {
            method: "POST",
            body: JSON.stringify(credentials),
        })

        const json = await res.json()
        const statusCode = json.statusCode.toLowerCase()
        if(statusCode.includes("success")) {
            setLoginInProcess(false)
            window.location.replace("/app")
            return
        }

        setLoginInProcess(false)
        setShowCredentialMismatch(true)
        grecaptcha.reset()
    }

    return (
        <div className="login-br1">
            <h5 className="heading-login">Account Login</h5>
            <form className="form" >
                <FloatingInput
                    classContainer="input"
                    classLabel="label"
                    props={{
                        autoComplete: "username",
                        className: "value",
                        maxLength: 60,
                        name: "username",
                        value: credentials.username,
                        onChange: (e) => {
                            setShowCredentialMismatch(false)
                            setCredentials({...credentials, username: e.target.value})
                        },
                        onKeyUp: (e) => e.key === "Enter" && handleSubmit,
                        "xd-qa-type":"textbox",
                        "xd-qa-name":"Username",
                    }}
                    required={false}
                    textLabel="Username"
                    type="text"
                />
                {
                    isApiTrue(themeScheme?.landingPwRetrieve) &&
                    <a
                        onClick={() => {
                            routerHistory?.push(URL_PASSWORD_RESET)
                        }}
                        className={`password-reset ${invert ? 'invert' : ''}`}
                        style={{
                            color: themeScheme?.xpresso?.menuBackgroundColor
                        }}
                        xd-qa-type="link"
                        xd-qa-name="Forgot Password"
                    >
                        Forgot Password?
                    </a>
                }
                <FloatingInput
                    classContainer="input"
                    classLabel="label"
                    props={{
                        autoComplete: "new-password",
                        className: "value",
                        maxLength: 64,
                        name: "password",
                        value: credentials.password,
                        onChange: (e) => {
                            setShowCredentialMismatch(false)
                            setCredentials({...credentials, password: e.target.value})
                        },
                        onKeyUp: (e) => e.key === "Enter" && handleSubmit,
                        "xd-qa-type":"textbox",
                        "xd-qa-name":"Password",
                    }}
                    required={false}
                    textLabel="Password"
                    type="password"
                />
                <div className="recaptcha" xd-qa-type="card" xd-qa-name="Recaptcha">
                    <ReCaptcha
                        onExpiration={() => setCredentials({...credentials, captcha: ""})}
                        onVerification={(value) => {
                            setShowCredentialMismatch(false)
                            setCredentials({...credentials, captcha: value})
                        }}
                    />
                </div>
                {
                    <p className={`error ${showCredentialMismatch && 'opaque'}`} xd-qa-type="text" xd-qa-name="Error Message">
                        Username or password incorrect.
                    </p>
                }

                <button
                    className={`login-button ${buttonEnabled() ? 'enabled' : 'disabled'}`}
                    style={{
                        backgroundColor: themeScheme?.xpresso?.menuBackgroundColor,
                        color: themeScheme?.xpresso?.menuTextColor
                    }}
                    onClick={(e) => {
                        e.preventDefault()
                        handleSubmit()
                    }}
                    disabled={!buttonEnabled()}
                    type="submit"
                    xd-qa-type="button"
                    xd-qa-name="Login"
                >
                    Login to Account
                </button>
            </form>
            {
                isApiTrue(themeScheme?.allowSignup)
                ? <span className="create-account">
                    <p>Don't have an account?</p>
                    <BrandedCreateAccount />
                 </span>
                : (isApiFalse(themeScheme?.allowSignup) && query.get("modal") === "newAccount")
                ? AlertModal({
                    header: "Error",
                    initShow: true,
                    cancelButton: false,
                    message: (
                        <span>
                            {themeScheme?.companyName} does not allow public account creation.<br/>
                            Please contact your administrator for assistance.<br/>
                            Click <a href="/app/xd/?modal=newAccount">here</a> to create an account in the public Xpressdocs storefront.
                        </span>
                    )
                })
                : <br />
            }
        </div>
    )
}

const URL_PASSWORD_RESET = '/password'
